export default [
    {
        path: 'relatorio-estatistico-status',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-estatistico-status' */
            '@/views/ambulatorio/relatorio-estatistico-status/Index'
        ),
        redirect: 'relatorio-estatistico-status/index',
        children: [
            {
                name: 'ambulatorio-relatorio-estatistico-status-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-estatistico-status' */
                    '@/views/ambulatorio/relatorio-estatistico-status/List.vue'
                ),
            },
        ],
    },
]